export const ru = {
    'chat-not-found': 'Чата с таким ID не существует',
    'text-error':
        'При добавлении чата произошла непредвиденная ошибка. Повторите попытку позже.'
};
